module.exports = __webpack_public_path__ + "static/media/templateQR.9ecaa693.png";